import React, { Component } from 'react';
import '../../App.css';
import BannerPrincipal from './banner-principal'
import BannerVideo from './banner-video'
import Row from '../reusables/row'
import Products from './products'
import Categories from './categories'
import Certifications from '../reusables/certifications'
import Footer from '../reusables/footer'

import videoprincipal from '../../video/video1.mp4'
import videorosas from '../../video/rose.mp4'
import videocamarones from '../../video/camarones.mp4'

class home extends Component {
  render() {
    return (
      <div className="home">
        {/* <Navbar/> */}
        <BannerPrincipal video={[videoprincipal]}
                title={['Pioricost Fruit']}
                linkto={["pioricost-fruit"]}
                description={['Благодаря нашему географическому положению, банан имеет «значительный размер, более однородную консистенцию, различный вкус и более интенсивный вкус», поэтому эквадорский банан является одним из лучших в мире.']}/>
        <Row label={['Послание от Совета директоров ']}
             description={['«Развитие страны - не результат удачи, а четких и правильных политических решений, наряду с инновациями и частными инвестициями, INEXLAM C.A стремится внести свой вклад и»']}
             author={['Даниэль Изуриэта-Баяс Президент и главный ']}
             charge={['исполнительный директор компании INEXLAM C.A.']}
             description2={['«Торгово-посредническая, как деятельность каждой страны, не только включает обмен продуктами, но и осуществляет крепких социальных отношений между стратегическими партнерами, INEXLAM C.A ежедневно работает над укреплением и ростом национальной и международной торговли»']}
             author2={['Яир Товар']}
             charge2={['ГЕНЕРАЛЬНЫЙ МЕНЕДЖЕР INEXLAM.C.A']}/>
        <Products/>
        <Row label={['Послание от Совета директоров ']}
             description={['«Развитие страны - не результат удачи, а четких и правильных политических решений, наряду с инновациями и частными инвестициями, INEXLAM C.A стремится внести свой вклад и»']}
             author={['Даниэль Изуриэта-Баяс Президент и главный ']}
             charge={['исполнительный директор компании INEXLAM C.A.']}
             description2={['«Торгово-посредническая, как деятельность каждой страны, не только включает обмен продуктами, но и осуществляет крепких социальных отношений между стратегическими партнерами, INEXLAM C.A ежедневно работает над укреплением и ростом национальной и международной торговли»']}
             author2={['Яир Товар']}
             charge2={['ГЕНЕРАЛЬНЫЙ МЕНЕДЖЕР INEXLAM.C.A']}/>
        {/* <Banner image={[bannersecundario]}
                title={['Lorem ipsum dolor sit amet, consectetur']}
                description={['Adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.']}/> */}
        
        <BannerVideo video={[videocamarones]}
                title={['Pioricost Fish']}
                linkto={['']}
                description={['Frescura, tamaño, cuidado ambiental, calidad y factor social han sido los pilares que han llevado al camarón ecuatoriano a convertirse en el más demandado a nivel mundial, y destronando al banano, como el primer producto de exportación no petrolera del país.']}/>
        <Categories/>
        <Row label={['Послание от Совета директоров ']}
             description={['«Развитие страны - не результат удачи, а четких и правильных политических решений, наряду с инновациями и частными инвестициями, INEXLAM C.A стремится внести свой вклад и»']}
             author={['Даниэль Изуриэта-Баяс Президент и главный ']}
             charge={['исполнительный директор компании INEXLAM C.A.']}
             description2={['«Торгово-посредническая, как деятельность каждой страны, не только включает обмен продуктами, но и осуществляет крепких социальных отношений между стратегическими партнерами, INEXLAM C.A ежедневно работает над укреплением и ростом национальной и международной торговли»']}
             author2={['Яир Товар']}
             charge2={['ГЕНЕРАЛЬНЫЙ МЕНЕДЖЕР INEXLAM.C.A']}/>
        <BannerVideo video={[videorosas]}
                title={['Pioricost Roses']}
                linkto={['']}
                description={['Tiendas tan exclusivas como Roseonly en China, han convertido a la rosa ecuatoriana en un símbolo de exclusividad, elegancia, buen gusto, variedad y sobre todo calidad. ']}/>
        <Certifications/>
        <Footer/>
      </div>
    );
  }
}

export default home;


// WEBPACK FOOTER //
// ./src/components/ru-home/index.js